import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// feature dispatch-board
import { getSelectedLoadGuids } from '../helpers';
//////////////////////////////////////////////////

const store = (state) => state.dispatchBoardClo;

const makeSelectSelectedList = () => createSelector(
  store,
  ({ itemList }) => getSelectedLoadGuids(itemList),
);

const makeSelectGroupBy = () => createSelector(
  store,
  ({ groupBy }) => groupBy,
);

const makeSelectGroupBySort = () => createSelector(
  store,
  ({ groupBySort }) => groupBySort,
);

const makeSelectReportStatus = () => createSelector(
  store,
  ({ reportPending }) => reportPending,
);

const makeSelectAvailableReports = () => createSelector(
  store,
  ({ availableReports }) => availableReports,
);

const makeSelectUsedReport = () => createSelector(
  store,
  ({ usedReport }) => usedReport,
);

const makeSelectItemList = () => createSelector(
  store,
  ({ itemList }) => G.ifElse(
    R.isNil(itemList),
    R.of(Array, { groupingObject: '', loads: {} }),
    itemList,
  ),
);

const makeSelectPagination = () => createSelector(
  store,
  ({ pagination }) => pagination,
);

const makeSelectTotalCount = () => createSelector(
  store,
  ({ totalCount }) => totalCount,
);

const makeSelectListLoading = () => createSelector(
  store,
  ({ loading }) => loading,
);

const makeSelectGlobalFilterValue = () => createSelector(
  store,
  ({ globalFilterValue }) => globalFilterValue,
);

const makeSelectSummary = () => createSelector(
  store,
  ({ summary }) => summary,
);

const makeSelectTableTitleFilters = () => createSelector(
  store,
  ({ tableTitleFilters }) => tableTitleFilters,
);

const makeSelectTitleSortValues = () => createSelector(
  store,
  ({ titleSortValues }) => titleSortValues,
);

const makeSelectShipUnitsExpanded = () => createSelector(
  store,
  ({ shipUnitsExpanded }) => shipUnitsExpanded,
);

const makeSelectGlobalFilterType = () => createSelector(
  store,
  ({ globalFilterType }) => globalFilterType,
);

const makeSelectCreatedByFilter = () => createSelector(
  store,
  ({ createdByFilter }) => createdByFilter,
);

const makeSelectShouldIgnoreFilters = () => createSelector(
  [
    R.path(['dispatchBoardClo', 'globalFilterValue']),
    R.path(['dispatchBoard', 'configs', GC.UI_CONFIG_GROUP]),
  ],
  (filter, configs) => {
    const config = G.getConfigValueFromStore(
      GC.UI_GLOBAL_SEARCH_IGNORE_FILTERS,
      configs,
    );

    return R.and(config, G.isNotNilAndNotEmpty(filter));
  },
);

export {
  makeSelectSummary,
  makeSelectGroupBy,
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectGroupBySort,
  makeSelectReportStatus,
  makeSelectSelectedList,
  makeSelectCreatedByFilter,
  makeSelectTitleSortValues,
  makeSelectGlobalFilterType,
  makeSelectAvailableReports,
  makeSelectGlobalFilterValue,
  makeSelectTableTitleFilters,
  makeSelectShipUnitsExpanded,
  makeSelectShouldIgnoreFilters,
};
